import { createStyles, Divider, List, ListItem, ListItemIcon, ListItemText, Paper, Theme, Typography } from "@material-ui/core"
import mainCss from '../../../../../assets/css/main.module.css';
import useRkCtxBo from "../../../../../consumer/rk/ctx-provider/useRkCtx";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import NumberUtil from "../../../../../app/util/NumberUtil";
import { getTextBeitrag, getTextZahlung } from "../../../../../consumer/form/dto/StvZahlungsweise";
import FormBoIhrTier from "../../step-ihr-tier/FormBo";
import EditIcon from '@material-ui/icons/EditOutlined';
import { makeStyles } from "@material-ui/styles";
import { getText as getTextSb } from "../../../../../consumer/form/dto/StvSelbstbeteiligung";
import { getText as getTextVs } from "../../../../../consumer/form/dto/StvVersicherungssumme";
import WizardStepContent from "../../WizardStepContent";
import TransitionFade from "../../../../transition/TransitionFade";
import AppTranslation from "../../../../../app/AppTranslation";
import { exportProduktMitSchutzbrief } from "../../step-angebot/produkt/Produkt";
import { exportSelbstbehalt } from "../../step-angebot/input/Selbstbehalt";
import { exportAnzahlHunde } from "../../step-ihr-tier/input/AnzahlHunde";
import { exportVs } from "../../step-angebot/input/Vs";

const useStyles = makeStyles((theme: Theme) => createStyles({
    nested: {
        paddingLeft: 27,
    },
}));

type ListItemCmpParam = {
    text?: string,
    nested?: boolean,
    onClick: (wizardStepIndex: number) => void,
    stepIndex: number
}

const ListItemCmp: React.FC<ListItemCmpParam> =
    ({ text, onClick, nested = false, stepIndex }) => {
        const classes = useStyles();
        return (
            <ListItem button
                style={{ justifyContent: 'space-between' }}
                onClick={() => onClick(stepIndex)}
                className={nested ? classes.nested : undefined}>

                <ListItemText disableTypography><Typography color='primary' variant='caption'>{text}</Typography></ListItemText>
                <ListItemIcon style={{ minWidth: 30 }}><EditIcon style={{ height: 20 }} color='primary' /></ListItemIcon>
            </ListItem>);
    }


const ProduktDevDesktop: React.FC = () => {
    const { wizardFormBo, handleBackPage } = useWizardFormCtx();
    const rkCtxBo = useRkCtxBo();

    const schutzbrief = exportProduktMitSchutzbrief(wizardFormBo.angebot);
    const schutzbriefText = schutzbrief ? 'mit Schutzbrief' : 'ohne Schutzbrief';

    const produktBeitrag = schutzbrief ? rkCtxBo.paketMitSchutzbrief?.bruttobeitragLautZw : rkCtxBo.paketOhneSchutzbrief?.bruttobeitragLautZw;
    const produktBeitragText = produktBeitrag ? NumberUtil.formatWaehrung(produktBeitrag) : "---";

    const zahlungsweiseText = rkCtxBo.zahlungsweise ? getTextZahlung(rkCtxBo.zahlungsweise) : "---";
    const zahlungsweiseTextBeitrag = rkCtxBo.zahlungsweise ? getTextBeitrag(rkCtxBo.zahlungsweise) : "---";

    const anzahlHunde = exportAnzahlHunde(wizardFormBo.ihrTier);
    const anzahlHundeTextg = `${anzahlHunde} ${anzahlHunde > 1 ? 'Hunde' : 'Hund'}`;

    const hunde = FormBoIhrTier.exportHunde(wizardFormBo.ihrTier);
    const titelText = AppTranslation.getProduktTitelAntrag(schutzbrief);

    const selbstbehalt = exportSelbstbehalt(wizardFormBo.angebot);
    const selbstbehaltText = getTextSb(selbstbehalt);

    const vs = exportVs(wizardFormBo.angebot);
    const vsText = getTextVs(vs);

    const stepIndexIhrTier = WizardStepContent.P_IHR_TIER.stepIndex;
    const stepIndexAngebot = WizardStepContent.P_ANGEBOT.stepIndex;

    const onClickEdit = (stepIndex: number) => {
        handleBackPage(stepIndex);
    }

    return (
        <TransitionFade>
            <Paper elevation={3} style={{ paddingBottom: 10 }}>
                <div className={mainCss.productSummaryHeaderDesktop} style={{ textAlign: 'center' }}>
                    <Typography color='textSecondary' variant='subtitle2'>{titelText}</Typography>
                </div>

                <div>
                    <List component="div" dense>
                        {/* Hund */}
                        <ListItemCmp text={anzahlHundeTextg} onClick={onClickEdit} stepIndex={stepIndexIhrTier} />
                        {hunde.map((hund, index) => (
                            <ListItemCmp key={index} text={hund.name} onClick={onClickEdit} nested stepIndex={stepIndexIhrTier} />
                        ))
                        }
                        {/* Selbstbehalt */}
                        <ListItemCmp text={selbstbehaltText} onClick={onClickEdit} stepIndex={stepIndexAngebot} />

                        {/* Schutzbrief */}
                        <ListItemCmp text={schutzbriefText} onClick={onClickEdit} stepIndex={stepIndexAngebot} />

                        {/* Versicherungs­summe */}
                        <ListItemCmp text={vsText} onClick={onClickEdit} stepIndex={stepIndexAngebot} />

                        {/* Zahlungsweise */}
                        <ListItemCmp text={zahlungsweiseText} onClick={onClickEdit} stepIndex={stepIndexAngebot} />

                    </List>
                </div>

                <Divider />

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', marginTop: 10, marginBottom: 10 }}>
                    <Typography color='textPrimary' variant='body1' style={{ fontSize: 26 }}>{produktBeitragText}</Typography>
                    <Typography color='textPrimary' variant='h6' style={{ marginLeft: 10 }}>{zahlungsweiseTextBeitrag}</Typography>
                </div>
            </Paper >
        </TransitionFade>
    );
}


export default ProduktDevDesktop;